import React, { Component } from 'react'
import { Modal } from 'hljd'
import { toJS } from 'mobx'
import { observer } from 'mobx-react'
@observer
class CloseModal extends Component {
  render() {
    const { store } = this.props
    const closeModalInfo = toJS(store.closeModalInfo)
    const { closeModalVisible, onCloseModalOk, onCloseMoalCancle } = store
    return (
      <Modal
        title={`关闭“${closeModalInfo.name}”品类`}
        visible={closeModalVisible}
        onOk={onCloseModalOk}
        onCancel={onCloseMoalCancle}
        okText="确认关闭"
      >
        <div className="close-modal-wrap">
          <p>
            关闭之后将产生如下后果：商家端该类目自建商品全部下架，直供商品全部删除。
          </p>
          <p>用户APP不再展示此品类的任何产品。</p>
          <p style={{ marginTop: '20px' }}>请谨慎操作！</p>
        </div>
      </Modal>
    )
  }
}

export default CloseModal
